<template>
    <div class="result-status">
        <p v-if="$route.params.city!==undefined">
            Hemos encontrado <span class="text-primary font700">{{roomslength}}</span> Salas de reuniones disponibles en
            <span
                    class="text-primary font700">{{$route.params.city}}</span>.
            <span v-if="roomslength>=1" class="font700"> Mostrando 1 - {{roomslength}}</span>
        </p>
        <p v-else>
            Hemos encontrado <span class="text-primary font700">{{roomslength}}</span> Salas de reuniones disponibles
            cerca tuyo
            <span v-if="roomslength>=1" class="font700"> Mostrando 1 - {{roomslength}}</span>
        </p>

    </div>
</template>
<script>
    export default {
        name: 'results',
        props: ['roomslength']
    }
</script>